import { useEffect, useState, useRef } from "react";
import { Send, Paperclip, User, Shield } from "lucide-react";
import { useParams } from "react-router-dom";
import useDocumentTitle from '../../hooks/useDocumentTitle'
import { getTicketMessages, sendTicketMessage } from "./ticketSlice";
import { useDispatch, useSelector } from "react-redux";
import ShimmerLoader from "../../components/ShimmerLoader";

export default function TicketChat() {
    useDocumentTitle('Ticket Chats');
    const dispatch = useDispatch();
    const { ticketId } = useParams();
    const [messages, setMessages] = useState([]);
    const [text, setText] = useState("");
    const [files, setFiles] = useState([]);
    const { MessageStatus, MessagesData } = useSelector((state) => state.tickets);
    const bottomRef = useRef(null);
    const chatEndRef = useRef(null);
    const [selectedStatus, setSelectedStatus] = useState("");
    const CLOSED_STATUS_IDS = [5, 6];





    useEffect(() => {
        fetchMessages();
    }, [ticketId]);

    const fetchMessages = async () => {
        dispatch(getTicketMessages({ ticketId }));
        scrollDown();
    };
    useEffect(() => {
        if (MessagesData?.ticket?.status_id) {
            setSelectedStatus(MessagesData.ticket.status_id);
        }
        if (MessagesData?.messages) {
            setMessages(MessagesData.messages);
        }

    }, [MessagesData]);
    const effectiveStatus =
        selectedStatus !== "" ? selectedStatus : MessagesData?.ticket?.status_id;
    const isTicketClosed = CLOSED_STATUS_IDS.includes(
        Number(effectiveStatus)
    );


    const scrollDown = () => {
        setTimeout(() => bottomRef.current?.scrollIntoView(), 100);
    };

    const sendMessage = async e => {
        e.preventDefault();

        await dispatch(
            sendTicketMessage({
                ticketId,
                text,
                files,
            })
        ).unwrap();

        setText('');
        setFiles([]);
        fetchMessages(); // or dispatch(getTicketMessages({ ticketId }))
    };

    const openAttachment = (filePath) => {
        // const url = filePath;
        window.open(filePath, "_blank");
    };
    useEffect(() => {
        chatEndRef.current?.scrollIntoView({ behavior: "smooth" });
    }, [messages]);
    return (
        <div className="bg-gray-100 text-gray-800 relative min-h-screen">
            {/* Main Content */}
            <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-6 space-y-6">
                <div className="flex flex-col h-[75vh] bg-white rounded-xl shadow">

                    {/* Header */}
                    <div className="p-4 border-b font-semibold flex items-center gap-2">
                        <Shield className="w-5 h-5 text-indigo-600" />
                        Ticket Conversation
                    </div>
                    {MessageStatus === "loading" ? (
                        <>
                            <div className="flex-1 overflow-y-auto p-4 space-y-4">
                                <ShimmerLoader />
                                <ShimmerLoader />
                                <ShimmerLoader />
                            </div>
                        </>
                    ) : (
                        <>
                            <div className="flex-1 overflow-y-auto p-4 space-y-4">
                                {messages && messages.length > 0 && messages.map(msg => {
                                    const isAgent = msg.sender?.UserType !== 2;
                                    return (
                                        <div
                                            key={msg.id}
                                            className={`flex ${isAgent ? "justify-start" : "justify-end"}`}
                                        >
                                            <div
                                                className={`max-w-xl border rounded-lg p-4 ${isAgent ? "bg-white" : "bg-blue-100"}
                                                                                                                            `}
                                            >
                                                <p className="flex items-center gap-2 mb-1 text-xs opacity-70">
                                                    {msg.isAgent ? <Shield className="w-3 h-3" /> : <User className="w-3 h-3" />}
                                                    {msg.sender?.name}
                                                </p>
                                                <p className="text-sm whitespace-pre-wrap">
                                                    {msg.message}
                                                </p>
                                                {/* Attachments */}
                                                {/* {msg.attachments?.length > 0 && (
                                                    <div className="mt-3 space-y-1">
                                                        {msg.attachments.map(att => (
                                                            <button
                                                                key={att.id}
                                                                onClick={() => openAttachment(att.file_path)}
                                                                className={`flex items-center gap-2 text-xs underline
                                                            ${isAgent ? "text-blue-600" : "text-blue-600"}
                                                            `}
                                                            >
                                                                <Paperclip size={14} />
                                                                {att.file_name}
                                                            </button>
                                                        ))}
                                                    </div>
                                                )} */}
                                                {msg.attachments?.length > 0 && (
                                                    <div className="mt-3 flex flex-wrap gap-2 ">
                                                        {msg.attachments.map(att => {
                                                            const isImage = att.file_type?.startsWith("image");

                                                            return isImage ? (
                                                                <img
                                                                    key={att.id}
                                                                    src={att.file_path}
                                                                    alt={att.file_name}
                                                                    onClick={() => openAttachment(att.file_path)}
                                                                    className="h-24 w-24 object-cover rounded-lg border cursor-pointer hover:opacity-90"
                                                                />
                                                            ) : (
                                                                <button
                                                                    key={att.id}
                                                                    onClick={() => openAttachment(att.file_path)}
                                                                    className="flex items-center gap-2 text-xs underline text-blue-600"
                                                                >
                                                                    <Paperclip size={14} />
                                                                    {att.file_name}
                                                                </button>
                                                            );
                                                        })}
                                                    </div>
                                                )}
                                                <p className="text-[11px] mt-2 opacity-70 text-right">
                                                    {msg.created_at}
                                                </p>
                                            </div>
                                        </div>
                                    );
                                })}
                                <div ref={chatEndRef} />
                            </div>
                        </>
                    )}


                    {/* Input */}
                    <form
                        onSubmit={isTicketClosed ? (e) => e.preventDefault() : sendMessage}
                        className="border-t p-4 bg-white flex flex-col gap-2"
                    >
                        {/* 🔒 Ticket Closed / Resolved Message */}
                        {isTicketClosed && (
                            <div className="bg-yellow-50 border border-yellow-200 text-yellow-800 text-sm rounded-lg p-3 flex items-center gap-2">
                                <Shield className="w-4 h-4" />
                                This ticket has been <strong>resolved</strong>.
                                If you still need help, please reopen the ticket or create a new one.
                            </div>
                        )}

                        {/* Attachments preview */}
                        {files?.length > 0 && !isTicketClosed && (
                            <div className="flex gap-2 overflow-x-auto pb-2">
                                {Array.from(files).map((file, index) => {
                                    const isImage = file.type.startsWith("image");

                                    return isImage ? (
                                        <img
                                            key={index}
                                            src={URL.createObjectURL(file)}
                                            alt="preview"
                                            onClick={() => openAttachment(URL.createObjectURL(file))}
                                            className="h-20 w-20 object-cover rounded-lg border cursor-pointer"
                                        />
                                    ) : (
                                        <div
                                            key={index}
                                            className="flex items-center gap-2 px-3 py-2 border rounded-lg text-xs bg-gray-50 whitespace-nowrap"
                                        >
                                            <Paperclip size={14} />
                                            {file.name}
                                        </div>
                                    );
                                })}
                            </div>
                        )}

                        {/* Input row */}
                        <div className={`flex items-center gap-2 ${isTicketClosed ? "opacity-60 pointer-events-none" : ""}`}>
                            {/* Attach */}
                            <input
                                type="file"
                                multiple
                                onChange={(e) => setFiles([...e.target.files])}
                                className="hidden"
                                id="attach"
                                disabled={isTicketClosed}
                            />
                            <label
                                htmlFor="attach"
                                className="p-2 rounded-full hover:bg-gray-100 cursor-pointer"
                            >
                                <Paperclip className="w-5 h-5 text-gray-600" />
                            </label>

                            {/* Text input */}
                            <input
                                value={text}
                                onChange={(e) => setText(e.target.value)}
                                placeholder={
                                    isTicketClosed
                                        ? "This ticket is closed"
                                        : "Type your message..."
                                }
                                className="flex-1 border rounded-full px-4 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                                disabled={isTicketClosed}
                                required={!isTicketClosed}
                            />

                            {/* Send button */}
                            <button
                                type="submit"
                                disabled={isTicketClosed}
                                className={`p-2 rounded-full flex items-center justify-center transition
                ${isTicketClosed
                                        ? "bg-gray-400 cursor-not-allowed"
                                        : "bg-indigo-600 hover:bg-indigo-700 text-white"
                                    }
            `}
                            >
                                <Send className="w-4 h-4" />
                            </button>
                        </div>
                    </form>


                </div>
            </main>
        </div>
    );
}
